// @flow
import React, { useMemo } from "react";
import { Provider } from "react-redux";
import DocumentTitle from "react-document-title";
import NotificationsContainer from "../../containers/NotificationsContainer";
import CreateTargetingContainer from "../../containers/CreateTargeting";
import configureStore from "./store";

function CreateTargeting() {
  const store = useMemo(configureStore, []);

  return (
    <DocumentTitle title="Targeting">
      <Provider store={store}>
        <NotificationsContainer />
        <CreateTargetingContainer />
      </Provider>
    </DocumentTitle>
  );
}

export default CreateTargeting;
